<template>
  <vue-dialog :dialog-data="dialogData" @confirm="confirm">
    <el-form :model="dialogForm" class="label-gray" label-width="120px" :rules="rules" ref="dialogForm">
      <el-form-item prop="name" label="权限列表" class="routes-tree-item">
        <template slot="label">
          <el-tooltip effect="dark" content="已添加的权限将无法勾选" placement="top-start">
            <el-button class="tips" icon="el-icon-info">权限列表</el-button>
          </el-tooltip>
        </template>
        <el-tree :data="routes"
                 :key="key"
                 ref="tree"
                 :props="defaultProps"
                 @check="treeCheck"
                 :render-content="treeContent"
                 :indent="35"
                 show-checkbox
                 node-key="value">
        </el-tree>
      </el-form-item>
    </el-form>
  </vue-dialog>
</template>

<script>
  import {changeEmpty} from '@utils/validate'
  import {getRoutesTree} from '@router/permission'
  export default {
    name: "AddPermission",
    props: {dialogData: Object},
    data() {
      return {
        defaultProps: {
          children: 'children',
          label: 'label',
        },
        dialogForm: {
          name: "",
        },
        rules: {
          name: [changeEmpty("需要添加权限")]
        },
        routes: getRoutesTree(),
        key: ""
      }
    },
    created() {
      this.getPermission();
    },
    methods: {
      treeContent(h, {data}) {
        return h("span", {class: data.icon}, data.label);
      },
      treeCheck(data, tree) {
        let list = tree.checkedKeys.filter(item => item);
        this.dialogForm.name = list.join(",");
        this.$refs["dialogForm"].validateField("name");
      },
      confirm() {
        this.$refs["dialogForm"].validate(async isOk => {
          if (isOk) {
            let nv = {...this.dialogForm};
            let res = await this.$Http.addPermission(nv);
            if (res) {
              this.msgSuccess("添加成功");
              this.$emit("table-reload");
              this.dialogData.visible = false;
            }
          }
        });
      },
      async getPermission() {
        let nv = {page:1, limit: 50};
        let res = await this.$Http.getPermissionList(nv);
        if (res?.data) {
          let list = res.data.list || [];
          let permissionName = list.map(item => item.name);
          this.$nextTick(() => {
            this.$refs.tree.setCheckedKeys(permissionName);
            let list = this.$refs.tree.getCheckedNodes();
            list.forEach(item => item.disabled = true);
            this.key = Date.now();
          });
        }
      },
    },
  }
</script>

<style scoped>

</style>
